import { render, staticRenderFns } from "./CaseInventoryManagementView.vue?vue&type=template&id=9bf75ca0"
import script from "./CaseInventoryManagementView.vue?vue&type=script&lang=js"
export * from "./CaseInventoryManagementView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports